import { useNavigate } from "react-router";

import { LandingPageSettings } from "@models/services/kiosk";
import handleResponse from "@services/apiConfig/api.response.service";
import API_SERVICES from "@services/index";
import { useQuery, UseQueryResult } from "@tanstack/react-query";

export const landingPageKeys = {
  detail: (kioskDeviceId: string) => ["landingPage", kioskDeviceId] as const,
  all: ["landingPage"] as const,
};

export function useLandingPageData(
  kioskDeviceId: string,
  options?: {
    enabled?: boolean;
    staleTime?: number;
    gcTime?: number;
  }
): UseQueryResult<LandingPageSettings, Error> {
  const navigate = useNavigate();
  return useQuery({
    queryFn: async () => {
      const response = await API_SERVICES.KIOSK.LANDING_PAGE();
      const responseData = handleResponse(response, navigate);

      if (!response.ok) {
        throw new Error("No landing page data returned");
      }
      return responseData.data;
    },
    enabled: options?.enabled !== false && !!kioskDeviceId,
    gcTime: options?.gcTime,
    queryKey: landingPageKeys.detail(kioskDeviceId),
    staleTime: options?.staleTime,
  });
}
